import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useTranslation } from 'next-i18next';
import { Container } from '../../../../../../components/HotelDetailsOverlay/components/AttributesSection/components/Attributes/components/Container.js';
import { Grid } from '../../../../../../components/HotelDetailsOverlay/components/AttributesSection/components/Attributes/components/Grid.js';
import { SectionIcon } from '../../../../../../components/HotelDetailsOverlay/components/AttributesSection/components/Attributes/components/SectionIcon.js';
import { InviaTypeIcon } from '../../../../../../components/InviaTypeIcon/index.js';
import { Flex, HeadlineMedium, HelpTooltip, LabelSmall, LabelXSmall, SegmentedList } from '../../../../../../primitives/index.js';
export const Attributes = ({
  title,
  attributes,
  highlighted = false,
  sectionName
}) => {
  const {
    t
  } = useTranslation('hotelDetailsOverlay');
  const LabelComponent = highlighted ? LabelSmall : LabelXSmall;
  const items = attributes.map(({
    translation,
    name: inviaType,
    value
  }, index) => _jsxs(Flex, {
    direction: "row",
    alignItems: "center",
    spacing: "16px",
    children: [highlighted && _jsx(InviaTypeIcon, {
      inviaType: inviaType,
      fontSize: "18px"
    }), _jsx(LabelComponent, {
      children: translation
    }), inviaType === 'IT03-ECO#GTI#GTI' && _jsx(HelpTooltip, {
      content: t('sustainability:hotelBadge.description', {
        certificate: value ? `(${value}).` : ''
      })
    })]
  }, index));
  return _jsxs(Container, {
    spacing: "16px",
    highlighted: highlighted,
    children: [_jsxs(Flex, {
      direction: "row",
      spacing: "headlines/large",
      children: [sectionName ? _jsx(SectionIcon, {
        name: sectionName
      }) : null, _jsx(HeadlineMedium, {
        children: title
      })]
    }), highlighted ? _jsx(Grid, {
      children: items
    }) : _jsx(SegmentedList, {
      rowSpacing: "8px",
      columnSpacing: "8px",
      items: items
    })]
  });
};